import { render, staticRenderFns } from "./aParityDashboardResume.vue?vue&type=template&id=45d9b6cd&scoped=true"
import script from "./aParityDashboardResume.vue?vue&type=script&lang=js"
export * from "./aParityDashboardResume.vue?vue&type=script&lang=js"
import style0 from "./aParityDashboardResume.vue?vue&type=style&index=0&id=45d9b6cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d9b6cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VBtn,VCol,VIcon,VRow,VSkeletonLoader})
